import { render, staticRenderFns } from "./AddMaterialToFolders.vue?vue&type=template&id=3c7accd5"
import script from "./AddMaterialToFolders.vue?vue&type=script&lang=js"
export * from "./AddMaterialToFolders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports